export enum SidebarNavItemIdEnum {
  HOME = 'home',
  APPS = 'apps',
  APPS_PERSONALISATION_STUDIO = 'appsPersonalisationStudio',
  PRODUCT_CATALOGUE = 'productCatalogue',
  ORDERS = 'orders',
  CLIENTS = 'clients',
  USERS = 'users',
  FEATURES = 'features',
  BILLING_ENTITIES = 'billingEntities',
  PAYMENT_TRANSACTIONS = 'paymentTransactions',
  PREPAYMENTS = 'prepayments',
  BANK_ACCOUNT = 'bankAccount',
  PRICE_PLANS = 'pricePlans',
  PRICE_CACHE_MANAGEMENT = 'priceCacheManagement',
  PRICE_PLAN_SUBSCRIPTIONS = 'pricePlanSubscriptions',
  PRODUCTION_CONFIGURATIONS = 'productionConfigurations',
  API_DOCUMENTATION = 'apiDocumentation',
  RESOURCE_CENTER = 'resourceCenter',
  SUPPORT = 'support',
  HELP_CENTER = 'helpCenter',
  SETTINGS = 'settings',
  SETTINGS_API_KEYS = 'settingsApiKeys',
  SETTINGS_NOTIFICATIONS = 'settingsNotifications',
  SETTINGS_RESALE_CERTIFICATES = 'settingsResaleCertificates',
  E_COMMERCE_STORES = 'eCommerceStores',
  E_COMMERCE_PRODUCT_TEMPLATES = 'eCommerceProductTemplates',
  ANALYTICS = 'analytics',
  GELATO_PLUS = 'gelatoPlus',
  DEVELOPER = 'developer',
  BRANDING = 'branding',
  BRANDING_CONFIGURE = 'brandingConfigure',
  BRANDING_DESIGNS = 'brandingDesigns',
  AUDIT_LOGS = 'auditLogs',
  MOCKUP_GALLERY = 'mockupGallery',
  PRICE_NAVIGATOR = 'priceNavigator',
  PRICE_NAVIGATOR_DASHBOARD = 'priceNavigatorDashboard',
  PRICE_NAVIGATOR_STRATEGIES = 'priceNavigatorStrategies',
  MOCKUP_STUDIO = 'mockupStudio',
  MOCKUP_STUDIO_CUSTOMER_TEMPLATES = 'mockupStudioCustomerTemplates',
  MOCKUP_STUDIO_GELATO_TEMPLATES = 'mockupStudioGelatoTemplates',
  MOCKUP_STUDIO_TEMPLATES_APPROVAL = 'mockupStudioTemplatesApproval',
}
